module.exports = __webpack_public_path__ + "img/69ABITO-SUGAR-XSSM-RIC.GRECIA-RIC.LIMONE-STAMPE-LINO4.dc6ba47b.jpg";